__turbopack_context__.v({
  "badgesRow": "AddOnCard-module-scss-module__JHdReG__badgesRow",
  "card": "AddOnCard-module-scss-module__JHdReG__card",
  "cardInner": "AddOnCard-module-scss-module__JHdReG__cardInner",
  "cardOverlayLink": "AddOnCard-module-scss-module__JHdReG__cardOverlayLink",
  "description": "AddOnCard-module-scss-module__JHdReG__description",
  "image": "AddOnCard-module-scss-module__JHdReG__image",
  "imageSection": "AddOnCard-module-scss-module__JHdReG__imageSection",
  "imageWrapper": "AddOnCard-module-scss-module__JHdReG__imageWrapper",
  "intro": "AddOnCard-module-scss-module__JHdReG__intro",
  "leftSection": "AddOnCard-module-scss-module__JHdReG__leftSection",
  "provider": "AddOnCard-module-scss-module__JHdReG__provider",
  "providerLabel": "AddOnCard-module-scss-module__JHdReG__providerLabel",
  "providerName": "AddOnCard-module-scss-module__JHdReG__providerName",
  "rightSection": "AddOnCard-module-scss-module__JHdReG__rightSection",
  "statusDot": "AddOnCard-module-scss-module__JHdReG__statusDot",
  "statusDotGreen": "AddOnCard-module-scss-module__JHdReG__statusDotGreen",
  "statusDotGrey": "AddOnCard-module-scss-module__JHdReG__statusDotGrey",
  "title": "AddOnCard-module-scss-module__JHdReG__title",
  "titleProvider": "AddOnCard-module-scss-module__JHdReG__titleProvider",
});
